import GeneratedMailAliasStore from "./generated/GeneratedMailAliasStore"

class MailAliasStore extends GeneratedMailAliasStore {

}

export const mailAliasStore = new MailAliasStore()
